import {useEffect, useRef, useState} from "react";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const TableSelect = (props) => {
  const {t} = useTranslation();
  const {options, onSelect, activeOption} = props;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(activeOption);

  const selectRef = useRef(null);

  const toggleSelect = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    onSelect(option);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={selectRef}
      className={styles.select}
    >
      <div
        className={styles.selectHeader}
        onClick={toggleSelect}
      >
        <RootDesc>
          <span>
            {t("table.select.show")} {selectedOption}
          </span>
        </RootDesc>

        <i
          style={
            isOpen ? {transform: "rotate(180deg)"} : {transform: "rotate(0deg)"}
          }
        />

        <RootDesc>
          <span>{t("table.select.entries")}</span>
        </RootDesc>
      </div>

      {isOpen && (
        <div className={styles.selectList}>
          <BorderArticle>
            <ul>
              {options.map((option) => (
                <li
                  key={option}
                  onClick={() => handleOptionClick(option)}
                  className={
                    selectedOption === option ? styles.activeOption : ""
                  }
                >
                  <RootDesc>
                    <span>{option}</span>
                  </RootDesc>
                </li>
              ))}
            </ul>
          </BorderArticle>
        </div>
      )}
    </div>
  );
};

export default TableSelect;
